import { FhirBinary, FhirExtractionContext } from '@oh-vcp/components-common';
import useFhirResourceEffect from './useFhirResourceEffect';

const useProcessedPatientFhirData = (
  configs: {
    data: any;
    setter: React.Dispatch<React.SetStateAction<string>>;
    type: string;
    setSelectedReports: React.Dispatch<React.SetStateAction<string[]>>;
    setBinaryItems: React.Dispatch<React.SetStateAction<FhirBinary[]>>;
    context?: FhirExtractionContext;
    enabled?: boolean;
  }[],
  enabled: boolean = true
) => {
  configs.forEach((config) => {
    useFhirResourceEffect(
      config.data,
      config.setter,
      config.type,
      config.setSelectedReports,
      enabled && (config.enabled ?? true),
      config.setBinaryItems,
      config.context
    );
  });
};

export default useProcessedPatientFhirData;
